<template>
    <paper class="work-driver-info">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="currentPage"
            searchId="_workDriver"
            pageID="workDriver_251216"
            @attachment-btn="handleAttachment"
            @approve-btn="handleApprove"
            @sign-btn="handleSign"
            @edit-btn="editBtn"
            @designate-btn="designateFn"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn" class="btn-box">
                <el-button
                    size="mini"
                    class="bigData-btn-data-desensitization"
                    :icon="isSensitive ? 'icon-show' : 'icon-hidden'"
                    @click="handleSensitive"
                ></el-button>
                <el-tooltip effect="dark" content="新增" placement="bottom" style="margin-left: 10px;" v-has="'08000301'">
                    <svg class="icon add-button" aria-hidden="true" @click="handleAdd">
                        <use xlink:href="#iconicon_newlyadd"></use>
                    </svg>
                </el-tooltip>
                <el-tooltip effect="dark" content="导出" placement="bottom" style="margin-left: 10px;" v-has="'08000302'">
                    <el-button class="export-button" size="mini"  @click="handleExport">
                        <svg class="icon" aria-hidden="true" @click="handleExport">
                            <use xlink:href="#iconicon_import"></use>
                        </svg>
                    </el-button>
                </el-tooltip>
            </div>
            <div slot="page-module-btn">
                <span class="enable-btn" v-has="'08000304'">
                    <el-button type="primary" :loading="enableLoading" @click="handleEnable">启用</el-button>
                </span>
                <span class="disable-btn" v-has="'08000303'">
                    <el-button type="primary" :loading="disableLoading" @click="handleDisable">停用</el-button>
                </span>
                <span class="disable-btn" v-if="wantDelegate">
                    <el-button type="primary" @click="handleDesignate">推送委派函</el-button>
                </span>
            </div>
        </m-pane>
        <add-or-edit-dialog :openAddOrEditDialog="openAddOrEditDialog"
                            :id="id"
                            :manage="false"
                            :supplierCode="supplierCode"
                            :supplierTab="supplierTab"
                            :addOrEdit.sync="addOrEdit"
                            :approve="approve"
                            :isShow='false'
                            :wantDelegate="wantDelegate"
                            :propertyNature="propertyNature"
                            :approvalStatus="approvalStatus"
                            @closeDialog="closeAddOrEditDialog"
                            @confirmDialog="confirmAddOrEditDialog">
        </add-or-edit-dialog>
        <attachment-dialog :id="id"
                           :config="attachmentConfig"
                           :openAttachmentDialog="openAttachmentDialog"
                           @closeAttachmentDialog="closeAttachmentDialog">
        </attachment-dialog>
        <ViewDelegateFile :visible.sync="showDelegateFlag" :id="appoinId"></ViewDelegateFile>
        <SmallDesignate  :visible.sync="showSmallDesignate" :selected="selected"></SmallDesignate>
        <sign-detail-dialog ref="signDetail"></sign-detail-dialog>
        <DelegateEnableDialog ref="dedRef" :supplierTab="supplierTab" @submit="handleGetData"></DelegateEnableDialog>
        <reviewTipsDialog ref="reviewTipsDialog"/>

    </paper>
</template>

<script>
import ViewDelegateFile from '../../manage/keyData/tabs/driver/viewDelegateFile.vue';
import SmallDesignate from '../../manage/keyData/tabs/driver/smallDesignate.vue';
import '@/styles/fonts/iconfont.js';
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import addOrEditDialog from '../../manage/keyData/tabs/driver/AddOrEditDialog.vue';
import { enableToLabel, enableToStatus } from '../../../../utils/statusOrLabel.js';
import { dictWithUrl } from '@/components/lots/api';
import attachmentDialog from '../../../../components/ViewAttachmentTable.vue';
import SignDetailDialog from '../../manage/keyData/tabs/driver/SignDetailDialog.vue';
import DelegateEnableDialog from '../../manage/keyData/tabs/driver/DelegateEnableDialog.vue';
import { getWorkbenchDrivers, enableDrivers, disableDrivers, getLoginUser, exportDriver,
    existApprovalDetail, wantDelegatePaperless, checkDelegatePhone } from '../../../../api/register/driver.js';
import { COMPANY } from '../../../../constant/constant.js';
import { getSensitiveVal } from '../../../../utils/common.js';
import reviewTipsDialog from '../../manage/keyData/tabs/driver/reviewTipsDialog.vue';
const THREE_HUNDRED = 300;
export default {
    name: 'my-driver',
    components: { mPane, paper, addOrEditDialog, attachmentDialog, ViewDelegateFile, SmallDesignate, SignDetailDialog, DelegateEnableDialog, reviewTipsDialog },
    props: {
        activeName: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            enableLoading: false, // 启用加载
            disableLoading: false, // 停用加载
            appoinId: '',
            wantDelegate: false, // 委派函试点控制
            showDelegateFlag: false, // 委派函弹窗控制
            showSmallDesignate: false, // 委派涵推送弹窗
            supplierCode: '',
            attachmentShow: false,
            openAttachmentDialog: false,
            openAddOrEditDialog: false,
            openBlackDialog: false,
            addOrEdit: false,
            approve: false,
            dict: {},
            countryList: [],
            provinceList: [],
            cityList: [],
            rowData: {},
            id: '',
            selected: [],
            searchDataLists: {},
            dataObj: {},
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            selectData: [],
            searchObj: {},
            pageTotal: 0,
            totalData: [],
            loading: false,
            labelPosition: 'right',
            config,
            attachmentConfig: {
                column: [
                    { prop: 'qualificationName', label: '资质名称' },
                    { prop: 'certificateBeginDate', label: '证件起始日期' },
                    { prop: 'certificateEndDate', label: '证件终止日期' }
                ],
                url: '/supplierDriverInfo/attachList/',
                id: ''
            },
            approvalStatus: '',
            isSensitive: true
        };
    },
    computed: {
        mipNum() {
            return this.$store.state.mipNum;
        },
        propertyNature() {
            return this.$store.state.supplier.propertyNature;
        },
        supplierTab() {
            const { supplierCode, supplierNameCn, supplierType, propertyNature } = this.$store.state.supplier;
            return { supplierCode, supplierName: supplierNameCn, supplierType, propertyNature };
        }
    },
    methods: {
        load() {},
        editBtn(data) {},
        pageChange(data) {
            this.pageNo = data;
            this.handleGetData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.handleGetData();
        },
        searchChange(data) {
            this.searchObj = data;
            this.pageNo = 1;
            this.handleGetData();
        },
        rowDBclick(row) {
            this.id = String(row.relationId);
            this.addOrEdit = false;
            this.approvalStatus = row.approvalStatus;
            this.openAddOrEditDialog = true;
        },
        handleGetData(params = { pageNo: this.pageNo, pageSize: this.pageSize }) {
            this.totalData = [];
            params = Object.assign(params, this.searchObj);
            getWorkbenchDrivers(JSON.stringify(params)).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data.totalCount;
                    this.totalData = res.data.list;
                    this.totalData.forEach(e => {
                        e.driverStatus = enableToLabel(e.driverStatus);
                    });
                    this.totalData = this.formatData(this.totalData);
                    this.setSensitiveData();
                }
            });
        },
        /** 导出 **/
        handleExport() {
            this.$confirm('是否确定导出?', '导出确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let params = {
                    supplierCode: this.supplierCode
                };
                params = { ...params, ...this.searchObj };
                exportDriver(JSON.stringify(params)).then(res => {
                    const blob = new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const objectUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = '司机信息';
                    a.click();
                    this.$message.success('导出成功');
                });
            });
        },
        handleEnable() {
            if (!this.selected.length) {
                this.$message.warning('当前没有选中的数据');
                return;
            }
            if (this.selected.some((e) => enableToStatus(e.driverStatus) === '0')) {
                this.$message.warning('勾选数据中有已启用数据');
            } else {
                if (this.supplierTab.propertyNature === COMPANY) {
                    const relationIdList = this.selected.map(item => item.relationId)
                    this.enableLoading = true
                    checkDelegatePhone({ supplierCode: this.supplierTab.supplierCode, relationIdList}).then(res => {
                        this.enableLoading = false
                        if (res && +res.code === 0) {
                            if (res.data && res.data.length) {
                                this.$refs.dedRef.open(res.data)
                            } else {
                                this.handleBatchOperation('enable', '启用')
                            }
                        }
                    }).catch(err => { this.enableLoading = false })
                } else {
                    this.handleBatchOperation('enable', '启用');
                }
            }
        },
        handleDisable() {
            if (!this.selected.length) {
                this.$message.warning('当前没有选中的数据');
                return;
            }
            if (this.selected.some((e) => enableToStatus(e.driverStatus) === '1')) {
                this.$message.warning('勾选数据中有已停用数据');
            } else {
                this.handleBatchOperation('disable', '停用');
            }
        },
        selectChange(data) {
            this.selected = [].concat(data);
        },
        /** 点击查询 调接口，拿table数据 **/
        handleSearch() {
            this.handleGetData();
        },
        /** 新增司机 **/
        handleAdd() {
            this.id = '';
            this.addOrEdit = true;
            this.openAddOrEditDialog = true;
        },
        /** 处理批量操作 **/
        handleBatchOperation(type, text) {
            this.$confirm('是否确定要' + text + '选择的数据?', text + '确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                const arr = [];
                this.selected.forEach(e => {
                    arr.push(String(e.relationId));
                });
                switch (type) {
                case 'enable':
                    //过滤复核不通过的数据
                    const reviewList = this.selected.filter((e) => e.reviewStatus === '30')
                    if (reviewList.length) {
                        this.$refs['reviewTipsDialog'].init(reviewList)
                        return;
                    }
                    this[type + 'Loading'] = true
                    enableDrivers(JSON.stringify(arr)).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.warning('启用成功!');
                            this.handleGetData();
                        }
                    }).finally(() => { this[type + 'Loading'] = false });
                    break;
                case 'disable':
                    this[type + 'Loading'] = true
                    disableDrivers(JSON.stringify(arr)).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.warning('停用成功!');
                            this.handleGetData();
                        }
                    }).finally(() => { this[type + 'Loading'] = false });
                    break;
                }
            });
        },
        /** 附件预览 **/
        handleAttachment(row) {
            this.attachmentConfig.id = String(row.relationId);
            this.openAttachmentDialog = true;
        },
        /** 审批详情 **/
        handleApprove(row) {
            existApprovalDetail(row.relationId).then(res => {
                if (res && res.code === '0') {
                    if (res.data) {
                        this.id = String(row.relationId);
                        this.approve = true;
                        this.openAddOrEditDialog = true;
                    } else {
                        this.$message.warning('当前司机无审批记录');
                    }
                }
            });
        },
        designateFn(row) {
            this.showDelegateFlag = true;
            this.appoinId = row.relationId;
        },
        /** 推送委派函 **/
        handleDesignate() {
            if (!this.selected.length) {
                this.$message.warning('至少勾选一项！');
                return;
            }
            this.showSmallDesignate = true;
        },
        /** 关闭查看附件弹窗 **/
        closeAttachmentDialog(data) {
            this.openAttachmentDialog = data;
            this.attachmentConfig.id = '';
        },
        closeAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
            setTimeout(() => {
                this.addOrEdit = data;
                this.approve = data;
                this.id = '';
                this.approvalStatus = '';
            }, THREE_HUNDRED);
        },
        confirmAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
            setTimeout(() => {
                this.addOrEdit = data;
                this.approve = data;
                this.id = '';
                this.approvalStatus = '';
                this.handleGetData();
            }, THREE_HUNDRED);
        },
        formatData(data) {
            return data.map(item => {
                item.blackFlag = this.dict.SRM_BLACK_FLAG[item.blackFlag];
                item.identificationFlag = this.dict.SRM_IDENTIFICATION_FLAG[item.identificationFlag];
                item.approvalStatus_ = this.dict.SRM_AUDIT_STATUS[item.approvalStatus];
                item.authenticationFlag = this.dict.SRM_YES_NO[item.authenticationFlag];
                item.reviewStatus_ = this.dict.SRM_DRIVER_CAR_REVIEW_STATUS[item.reviewStatus];
                //复核不通过才标红
                if(item.reviewStatus === '30'){
                    item._reviewStatus_ClassName = 'red-tips'
                    item._reviewFailReasonClassName = 'red-tips'
                }
                if (!item.contractNo) {
                    item.hiddenEvent = ['sign'];
                }
                return item;
            });
        },
        handleSensitive() {
            this.isSensitive = !this.isSensitive;
            this.setSensitiveData();
        },
        setSensitiveData() {
            this.totalData.forEach(item => {
                this.$set(item, 'drivingLicence_', this.isSensitive && item.drivingLicence ? getSensitiveVal(item.drivingLicence, 'idCard') : item.drivingLicence)
                this.$set(item, 'idCard_', this.isSensitive && item.idCard ? getSensitiveVal(item.idCard, 'idCard') : item.idCard);
                this.$set(item, 'phoneNo_', this.isSensitive && item.phoneNo ? getSensitiveVal(item.phoneNo, 'phone') : item.phoneNo);
                this.$set(item, 'familyAddress_', this.isSensitive && item.familyAddress ? getSensitiveVal(item.familyAddress, 'address') : item.familyAddress)
            });
        },
        wantDelegatePaperlessFn() {
            wantDelegatePaperless(this.supplierCode).then(res => {
                if (res && res.code === '0') {
                    this.wantDelegate = res.data;
                    if (this.wantDelegate) {
                        const flag = config.searchList.searchTxt.find(el => {
                            return el.label === '委派函状态';
                        });
                        const flag1 = config.table.action.find(el => {
                            return el.label === '委派函';
                        });
                        !flag && config.searchList.searchTxt.push({
                            'name': '委派函状态',
                            'value': 'delegateStatus',
                            'type': 'select',
                            'unfold': true,
                            'span': 3,
                            'options': [
                                {
                                    value: '0',
                                    label: '未签署'
                                },
                                {
                                    value: '1',
                                    label: '签署中'
                                },
                                {
                                    value: '2',
                                    label: '当月到期'
                                }
                            ],
                            'multiple': false
                        });
                        !flag1 && config.table.action.push({
                            'type': 'text',
                            'label': '委派函',
                            'size': 'mini',
                            'event': 'designate'
                        });
                    }
                }
            });
        },
        handleSign(row) {
            this.$refs.signDetail.handleOpen(row.contractNo);
        }
    },
    mounted() {
        if(this.$route.query.reviewStatus && this.mipNum === 1){
            this.$store.commit('setMipNum', this.mipNum + 1);
            this.$nextTick(() => {
                try{
                    this.$refs.tablePage.$refs.searchList.searchData.reviewStatusList = [this.$route.query.reviewStatus];
                    this.searchObj.reviewStatusList = [this.$route.query.reviewStatus];
                }catch(err){}
            })
        }
        dictWithUrl('SRM_BLACK_FLAG,SRM_IDENTIFICATION_FLAG,SRM_AUDIT_STATUS,SRM_YES_NO,SRM_DRIVER_CAR_REVIEW_STATUS').then(res => {
            this.dict = res.data;
            getLoginUser().then(res => {
                if (res && res.code === '0') {
                    this.supplierCode = res.data.supplierCode;
                    // 委派函试点
                    this.wantDelegatePaperlessFn();
                    this.handleGetData();
                }
            });
        });
    }
};
</script>

<style lang="less">
    .work-driver-info {
        margin: 7px;
        min-width: 1200px;

        #mPane3 .el-table {
            min-height: calc(100vh - 165px);
            max-height: calc(100vh - 165px);
        }

        .enable-btn,
        .disable-btn {
            margin-left: 10px;
        }

        .icon {
            overflow: hidden;
            width: 1em;
            height: 1em;
            vertical-align: -0.15em;
            fill: currentcolor;
            cursor: pointer;
        }

        .add-button {
            font-size: 28px;
        }

        .export-button {
            .icon {
                font-size: 12px;
            }
        }
        .red-tips{
            color: red;
        }
    }
</style>
